import { memo } from 'react';
import { Card, CardMedia, Chip, Typography, Box, Grid, Link, CardContent, CardActionArea } from '@mui/material';
import ColorChartThumbnail from '../components/charts/ColorChartThumbnail';
import { objectToArray } from '../utils';
import ColorThumbnail from '../Chart/ColorThumbnail';

const WorkspaceCard = memo(({ item, isExpandedView, searchKeyword, navigate }) => {
  const CardChips = ({ item }) => {
    return (
      <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap', mt: 1 }}>
        {item.patterns && item.patterns.length > 0 && <Chip size="small" variant="outlined" label={`Patterns (${item.patterns.length})`} />}
        {item.parts && item.parts.length > 0 && <Chip size="small" variant="outlined" label={`Parts (${item.parts.length})`} />}
        {item.motifs && item.motifs.length > 0 && <Chip size="small" variant="outlined" label={`Motifs (${item.motifs.length})`} />}
        {item.layouts && objectToArray(item.layouts).length > 0 && (
          <Chip size="small" variant="outlined" label={`Layouts (${objectToArray(item.layouts).length})`} />
        )}
        {item.colorways && objectToArray(item.colorways).length > 0 && (
          <Chip size="small" variant="outlined" label={`Colorways (${objectToArray(item.colorways).length})`} />
        )}
      </Box>
    );
  };

  // Helper to get motifs as array
  const getMotifArray = (motifs) => {
    if (!motifs) return [];
    if (Array.isArray(motifs)) return motifs;
    if (typeof motifs === 'object') return objectToArray(motifs);
    return [];
  };

  // Helper to render motif cards
  const renderMotifCards = (motifs, searchKeyword) => {
    return getMotifArray(motifs)
      .filter((motif) => (motif.keywords || '').toLowerCase().includes(searchKeyword.toLowerCase()))
      .map((motif, idx) => (
        <Grid item xs={12} sm={6} md={4} key={motif.id || idx}>
          <Card
            variant="outlined"
            sx={{
              p: 2,
              cursor: 'pointer',
              '&:hover': { boxShadow: 1 },
              backgroundColor: 'background.default'
            }}
            onClick={() => navigate(`/workspaces/${item.pk}/${item.id}/motifs/${motif.id || idx}`)}
          >
            <Typography variant="subtitle1" sx={{ mb: 1 }}>
              {motif.name}
            </Typography>
            <ColorChartThumbnail data={motif.data} colors={motif.colors} mincols={24} settings={motif.settings} />
            <ColorThumbnail
                          colordata={motif.colordata || motif.data}
                          colors={motif.colors}
                          width={120}
                          height={120}
                          view="rough"
                          cellRatio="1:1"
                          showGrid={false}
                          settings={motif.settings}
                        />
            <Typography variant="body2" sx={{ mt: 1 }}>
              {motif.keywords}
            </Typography>
          </Card>
        </Grid>
      ));
  };

  return isExpandedView ? (
    <Card variant="outlined">
      <Box sx={{ display: 'flex', flexDirection: 'row', gap: 2, p: 2 }}>
        {item.picture && (
          <CardMedia
            component="img"
            image={item.picture}
            alt={item.name}
            sx={{ height: 100, width: 100, objectFit: 'cover', borderRadius: 1 }}
          />
        )}
        <Box sx={{ flex: 1 }}>
          <Typography variant="h6" sx={{ mb: 1 }}>
            <Link onClick={() => navigate(`/workspaces/${item.pk}/${item.id}`)} underline="hover" sx={{ cursor: 'pointer' }}>
              {item.name}
            </Link>
          </Typography>
          <Typography
            variant="body2"
            sx={{
              display: '-webkit-box',
              WebkitBoxOrient: 'vertical',
              WebkitLineClamp: 2,
              overflow: 'hidden',
              mb: 1,
              color: 'text.secondary'
            }}
          >
            {item.description}
          </Typography>
          <CardChips item={item} />
        </Box>
      </Box>
      <Grid container spacing={2} sx={{ p: 2, pt: 0 }}>
        {renderMotifCards(item.motifs, searchKeyword)}
      </Grid>
    </Card>
  ) : (
    <Card
      variant="outlined"
      sx={{
        width: 200,
        '&:hover': {
          boxShadow: 1
        }
      }}
      onClick={() => navigate(`/workspaces/${item.pk}/${item.id}`)}
    >
      {item.picture && (
        <CardMedia component="img" image={item.picture} alt={item.name} sx={{ height: 140, width: 200, objectFit: 'cover' }} />
      )}
      <CardActionArea>
        <CardContent>
          <Typography variant="h6">{item.name}</Typography>
          <Typography
            variant="body2"
            sx={{
              display: '-webkit-box',
              WebkitBoxOrient: 'vertical',
              WebkitLineClamp: 2,
              overflow: 'hidden'
            }}
          >
            {item.description}
          </Typography>
          <CardChips item={item} />
        </CardContent>
      </CardActionArea>
    </Card>
  );
});

export default WorkspaceCard;
